/* Collections list page — builds the filter pill bar from the "Collections
   category" sections present on the page, and filters them on click.
   Category sections can be added/removed/reordered in the theme editor;
   the pills always reflect what is actually rendered. */

(function () {
  var currentFilter = 'all';

  function getGroups() {
    return Array.from(document.querySelectorAll('[data-clx-group]'));
  }

  function syncAllPill() {
    var allPill = document.querySelector('[data-clx-filter="all"]');
    if (allPill) {
      // Only offer "All" as a way back once a category filter is active
      allPill.toggleAttribute('hidden', currentFilter === 'all');
    }
  }

  function applyFilter(value) {
    currentFilter = value;
    syncAllPill();

    document.querySelectorAll('[data-clx-filter]').forEach(function (pill) {
      var isActive = pill.dataset.clxFilter === value;
      pill.classList.toggle('is-active', isActive);
      pill.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    });

    getGroups().forEach(function (group) {
      var show = value === 'all' || group.dataset.clxGroup === value;
      if (show) {
        group.removeAttribute('hidden');
        group.classList.remove('clx-group--entering');
        // restart the fade-in animation
        void group.offsetWidth;
        group.classList.add('clx-group--entering');
      } else {
        group.setAttribute('hidden', '');
      }
    });
  }

  function buildPills() {
    var bar = document.querySelector('[data-clx-filter-bar]');
    if (!bar) return;
    var scroll = bar.querySelector('.clx-filter-bar__scroll');
    var groups = getGroups();

    // Remove previously generated pills (keep the static "All" pill)
    scroll.querySelectorAll('[data-clx-filter]:not([data-clx-filter="all"])').forEach(function (pill) {
      pill.remove();
    });

    if (groups.length < 2) {
      bar.setAttribute('hidden', '');
      return;
    }
    bar.removeAttribute('hidden');

    var seen = {};
    groups.forEach(function (group) {
      var handle = group.dataset.clxGroup;
      if (!handle || seen[handle]) return;
      seen[handle] = true;
      var pill = document.createElement('button');
      pill.type = 'button';
      pill.className = 'clx-filter-pill';
      pill.dataset.clxFilter = handle;
      pill.setAttribute('aria-pressed', 'false');
      pill.textContent = group.dataset.clxLabel || handle;
      scroll.appendChild(pill);
    });

    syncAllPill();
  }

  function init() {
    buildPills();

    // Deep link support: /collections#coffee, /collections#gear, etc.
    var hash = window.location.hash.replace('#', '');
    if (hash && document.querySelector('[data-clx-filter="' + CSS.escape(hash) + '"]')) {
      applyFilter(hash);
    }
  }

  // One delegated listener; survives pill rebuilds
  document.addEventListener('click', function (event) {
    var pill = event.target.closest('[data-clx-filter]');
    if (!pill) return;
    var value = pill.dataset.clxFilter;
    applyFilter(value);
    if (history.replaceState) {
      history.replaceState(null, '', value === 'all' ? window.location.pathname : '#' + value);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Keep pills in sync while editing in the theme customizer
  document.addEventListener('shopify:section:load', function () {
    setTimeout(buildPills);
  });
  document.addEventListener('shopify:section:unload', function () {
    setTimeout(buildPills);
  });
  document.addEventListener('shopify:section:reorder', function () {
    setTimeout(buildPills);
  });
})();
